export default function isAmeelioTablet() {
  const userAgent = navigator.userAgent.toLowerCase();
  // The models are the ones that are known to be Ameelio tablets
  // Matches the model followed by any word characters
  const models = [/sm-t510\w*/, /sm-x210\w*/];
  return models.some((pattern) => pattern.test(userAgent));
}
